// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Spin/index.less
// module id = 1728
// module chunks = 0